export const CLERK_AI_DEFAULT_WIDTH = 420;
export const CLERK_AI_MIN_WIDTH = 320;
export const CLERK_AI_MAX_WIDTH = 960;
export const CLERK_AI_MIN_APP_WIDTH = 320;
export const CLERK_AI_RESIZE_STEP = 20;
export const CLERK_AI_PREFS_KEY = 'clerkAiPanel';

// Topic labels are business terms, never data-source names (spec BR-017).
export const CLERK_AI_STARTER_PROMPTS = [
  {
    topic: 'Unbilled time',
    question: 'Which matters have the most unbilled time this month?',
  },
  {
    topic: 'Team hours',
    question: 'Summarize work done last week by clients and attorneys?',
  },
  {
    topic: 'Collections',
    question: 'Collections trends over the past 12 months?',
  },
  {
    topic: 'Realization',
    question: 'What is our realization rate by attorney this year?',
  },
] as const;
